import { logAndNotifyError } from "../modules/logger";
import Notify from "devextreme/ui/notify";
import { useCallback, useEffect, useMemo, useState } from "react";
import { get, getUserInfo, post, switchCustomer } from "../modules/server";
import { EventInfo } from "devextreme/events";
import { DataGrid } from "devextreme-react";

import ArrayStore from "devextreme/data/array_store";
import dxDataGrid, { EditingStartEvent, NewRowInfo, RowDblClickEvent } from "devextreme/ui/data_grid";
import { Button, Column, Editing, Form, Popup } from "devextreme-react/data-grid";
import { Card } from "react-bootstrap";

// interface IMutableRef {
//   instance?: dxHtmlEditor;
// }

const Customers = () => {
  const [customers, setCustomers] = useState<ArrayStore<any, any>>();
  const [isLoading, setIsLoading] = useState(false);
  const [isNewRow, setIsNewRow] = useState(false);

  const userInfo = getUserInfo();

  const onInitNewRow = useCallback(
    (e: EventInfo<dxDataGrid<any, any>> & NewRowInfo<any>) => {
      setIsNewRow(true);
    },
    [setIsNewRow]
  );

  const onEditingStart = useCallback(
    (e: EditingStartEvent) => {
      setIsNewRow(false);
    },
    [setIsNewRow]
  );

  const customizeItem = useCallback(
    (item: any) => {
      if (isNewRow) {
      }
    },
    [isNewRow]
  );

  const onCellPrepared = useCallback((e: any) => {
    const companyId = getUserInfo()?.customerId;
    if (e.column.type === "buttons" && e.rowType === "data") {
      if (e.row.data.id === companyId) {
        for (var i = 0; i < e.cellElement.children.length; i++) {
          const child = e.cellElement.children[i];
          if (child?.ariaLabel === "Delete") {
            child.style.visibility = "hidden";
          }
          // if (child?.className.includes("dx-icon-arrowright")) {
          //   child.style.visibility = "hidden";
          // }
        }
      }
    }
  }, []);

  useEffect(() => {
    fetchCustomers();
  }, []);

  // const def: IMutableRef = { instance: undefined };
  // const selfref = useRef(def);

  const fetchCustomers = async () => {
    setIsLoading(true);
    var result = await get("Admin/Customers");

    const ds = new ArrayStore({
      data: result.customers,
      key: "id",
      onUpdated: async function (id) {
        const item = result.customers.find((r: any) => r.id === id);
        const saveResp = await post("Admin/SaveCustomer", item);
        if (saveResp.success) Notify("Ändringarna har sparats", "success");
        else logAndNotifyError("Ett fel uppstod när ändringarna skulle sparas : " + saveResp.error);
      },
      onRemoved: async function (id) {
        const deleteResp = await get("Admin/RemoveCustomer/" + id);
        if (!deleteResp.success) {
          logAndNotifyError("Ett fel uppstod när kunden skulle tas bort : " + deleteResp.error);
          fetchCustomers();
        } else Notify("Kunden har tagits bort", "success");
      },
      onInserted: function (item) {},
    });

    setCustomers(ds);
    setIsLoading(false);
  };

  const onRowDblClick = useCallback((e: RowDblClickEvent) => {
    var dg = e.component;
    var rowIndex = e.rowIndex;
    dg.editRow(rowIndex);
  }, []);

  const columns = useMemo(() => {
    const fields: any[] = [
      { dataField: "id", visible: false, showInColumnChooser: false },
      { dataField: "name", caption: "Kundnamn", fixed: true, minWidth: 50, width: 150 },
      { dataField: "number", caption: "Kundnummer", fixed: true, minWidth: 50, width: 150 },
      { dataField: "lastSubscriptionUpdate", caption: "Abonnemanget ändrades senast", dataType: "date" },
      { dataField: "attention", caption: "Uppmärksamma", fixed: true, width: 150 },
      { dataField: "street", caption: "Gatuadress" },
      { dataField: "postalCode", caption: "Postnummer" },
      { dataField: "city", caption: "Ort" },
      { dataField: "email", caption: "E-post" },
      { dataField: "phoneNumber", caption: "Telefon" },
      { dataField: "orderReference", caption: "Orderreferens" },
      { dataField: "invoiceReference", caption: "Fakturareferens" },
      { dataField: "prefersEDIInvoice", caption: "EDI-faktura", dataType: "boolean" },
      { dataField: "prefersPDFInvoice", caption: "PDF-faktura", dataType: "boolean" },
      { dataField: "emailInvoice", caption: "email faktura" },
      { dataField: "hasAcceptedConditions", caption: "Har accepterat villkoren", visible: false },
      { dataField: "licenceXUsers", dataType: "number", caption: "Licens X användare", visible: false, showInColumnChooser: false },
      { dataField: "licenceMaxBuildings", dataType: "number", caption: "Licens max X byggnader" },
      { dataField: "licenceMaxBuildingsArea", dataType: "number", caption: "Licens max byggnadsyta" },
      { dataField: "licenceExpirationDate", dataType: "date", caption: "Licens giltig t.o.m." },
      { dataField: "createdDate", dataType: "date", caption: "Skapad" },

      {
        type: "buttons",
        // width: 300,
        buttons: [
          { name: "delete", icon: "remove", hint: "Ta bort" },
          { name: "edit", icon: "edit", hint: "Redigera" },
          {
            text: "Command",
            icon: "arrowright",
            hint: "Byt till det här företaget",
            itemType: "button",
            onClick: (e: any) => {
              // Execute your command here
              const custId = e.row.data.id;
              switchCustomer(custId);
            },
            onInitialized: (e: any) => {
              e.component.option("elementAttr", { "aria-label": "Switch" });
            },
          },
        ],
      },
    ];

    return fields;
  }, []);

  const items = useMemo(() => {
    const fields: any[] = [
      // { dataField: "id", visible: false },
      // { dataField: "name" },
      // { dataField: "address" },
      // { dataField: "licenceXUsers", dataType: "number" },
      // { dataField: "licenceMaxBuildings", dataType: "number" },
      // { dataField: "licenceMaxBuildingsArea", dataType: "number" },
      // { dataField: "licenceExpirationDate", dataType: "date" },
      { dataField: "id", visible: false },

      { dataField: "name", caption: "Kundnamn" },
      { dataField: "number", caption: "Kundnummer" },
      { dataField: "email", caption: "E-post" },
      { dataField: "phoneNumber", caption: "Telefon" },
      { dataField: "lastSubscriptionUpdate", caption: "Abonnemanget ändrades senast", disabled: true, dataType: "date" },
      {
        itemType: "empty",
      },
      { dataField: "attention", caption: "Uppmärksamma", editorType: "dxTextArea", colSpan: 2, editorOptions: { height: 80 } },

      {
        itemType: "group",
        caption: "Adress",
        colSpan: 2,
        colCount: 2,
        items: [
          { dataField: "street", caption: "Gatuadress" },
          { dataField: "postalCode", caption: "Postnummer" },
          { dataField: "city", caption: "Ort" },
        ],
      },
      {
        itemType: "group",
        caption: "Fakturauppgifter",
        colSpan: 2,
        colCount: 2,
        items: [
          { dataField: "orderReference", caption: "Orderreferens" },
          { dataField: "invoiceReference", caption: "Fakturareferens" },
          { dataField: "prefersEDIInvoice", caption: "EDI-faktura", dataType: "boolean" },
          { dataField: "prefersPDFInvoice", caption: "PDF-faktura", dataType: "boolean" },
          { dataField: "emailInvoice", caption: "email faktura" },
        ],
      },
      {
        itemType: "group",
        caption: "Licensuppgifter",
        colSpan: 2,
        colCount: 2,
        items: [
          { dataField: "hasAcceptedConditions", caption: "Har accepterat villkoren", disabled: true, dataType: "boolean" },
          { dataField: "licenceExpirationDate", dataType: "date", caption: "Licens giltig t.o.m." },
          { dataField: "licenceXUsers", dataType: "number", caption: "Licens X användare", visible: false },
          { dataField: "licenceMaxBuildings", dataType: "number", caption: "Licens max X byggnader" },
          { dataField: "licenceMaxBuildingsArea", dataType: "number", caption: "Licens max byggnadsyta" },
        ],
      },
    ];

    return fields;
  }, []);

  return (
    <>
      {isLoading && <div>Loading...</div>}
      {!isLoading && (
        <Card>
          <Card.Header>Hantera Kunder/företag</Card.Header>
          <Card.Body>
            <DataGrid
              height={700}
              dataSource={customers}
              selection={{ mode: "single" }}
              paging={{ enabled: false }}
              scrolling={{ mode: "virtual" }}
              columns={columns}
              onRowDblClick={onRowDblClick}
              onInitNewRow={onInitNewRow}
              onEditingStart={onEditingStart}
              onCellPrepared={onCellPrepared}
              headerFilter={{ visible: true }}
              //       allowColumnReordering: true,
              // allowColumnResizing: true,
              // columnAutoWidth: true,
              // showBorders: true,
              // columnChooser: {
              //   enabled: true,
              // },
              allowColumnReordering={true}
              allowColumnResizing={true}
              columnAutoWidth={true}
              showBorders={true}
              columnChooser={{
                enabled: true,
              }}
            >
              <Editing mode="popup" allowUpdating={true} allowAdding={false} allowDeleting={true}>
                <Form customizeItem={customizeItem} items={items}></Form>
                <Popup title={isNewRow ? "Lägg till ny kund" : "Kund-info"} showTitle={true} />
              </Editing>
            </DataGrid>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default Customers;
